export const PERMISSION_DENY_LABEL = "You don't have permission";
